import { Link } from 'react-router-dom';
import './Breadcrumb.css';

export function Breadcrumb({ items = [] }) {
  const ancestors = items.slice(0, -1);
  const current = items[items.length - 1];

  if (!current || items.length < 2) return null;

  return (
    <nav key={current.label} aria-label="Breadcrumb" className="ps-breadcrumb">
      <ol className="ps-breadcrumb__list">
        {ancestors.map((crumb) => (
          <li key={crumb.path ?? crumb.label} className="ps-breadcrumb__item">
            {crumb.canAccess !== false ? (
              <Link
                to={crumb.path}
                className="ps-breadcrumb__link"
                title={crumb.label}
              >
                <span className="ps-breadcrumb__label">{crumb.label}</span>
              </Link>
            ) : (
              <span className="ps-breadcrumb__plain">{crumb.label}</span>
            )}
            <i
              className="bi bi-chevron-right ps-breadcrumb__sep"
              aria-hidden="true"
            />
          </li>
        ))}
        <li
          className="ps-breadcrumb__item ps-breadcrumb__item--current"
          aria-current="page"
        >
          <span
            className="ps-breadcrumb__label ps-breadcrumb__label--current"
            title={current.label}
          >
            {current.label}
          </span>
        </li>
      </ol>
    </nav>
  );
}
